module.exports = __webpack_public_path__ + "static/media/bed.05093bc3.svg";